module.exports = __webpack_public_path__ + "img/3.8a69b98c.jpg";